import request from './axios.js';

const api = {
  getPrintClientHistory: ['/client-update/client-history-v2', 'get'],
};
let key = null;
const apiObj = {};
for (key in api) {
  if ({}.hasOwnProperty.call(api, key)) {
    const [url, type, linkParams] = api[key];
    if (linkParams) {
      apiObj[key] = (urlString, params = {}, ...arg) => request[type](url + urlString, params, ...arg);
    } else if (type === 'get') {
      apiObj[key] = (params, ...arg) => request[type](url, { params }, ...arg);
    } else {
      apiObj[key] = (params, ...arg) => request[type](url, params, ...arg);
    }
  }
}
export default apiObj;
